
window.addEventListener('load', function() {
    document.querySelectorAll('.order-value-booster-block').forEach( function(widget) {
      let id = widget.getAttribute('id');
      console.log("ID:", id);
      waitForElement(`#essential_product_slider_${id}`, 3000)
      .then(function(el) {
        if(!window.Glide) return;
        el.querySelectorAll('.glide__slide--clone').forEach(function(clone) {
          clone.remove();
        });
        let slider = new Glide(`#essential_product_slider_${id}`, {
          type: "carousel",
          gap: 30,
          peek: 0,
          perView: 1,
          breakpoints: {
              768: { perView: 1 },
              480: { perView: 1 }
          }
        });
        slider.mount();
      })
      .catch(function(err) {
        console.warn(err);
      });
    });          

    function waitForElement(selector , timeout = 10000) {
      return new Promise(function(resolve, reject) {
        const interval = 100; // ms
        const start = Date.now();

        const timer = setInterval(function() {
          let el = document.querySelector(selector);
          if (el) {
            clearInterval(timer);
            resolve(el);
          } else if (Date.now() - start > timeout) {
            clearInterval(timer);
            reject(new Error('Timed out waiting for ' + selector));
          }
        }, interval);
      });
    }    
  });